import type { ContactRequestValue } from '../types';
import { parseAmount } from './parseAmount';

export const PRICE_FIELD_KEYS = ['netPrice', 'vatRate', 'grossPrice'] as const;
export type PriceFieldKey = (typeof PRICE_FIELD_KEYS)[number];

export function recalculatePrices(
    editedKey: PriceFieldKey,
    values: ContactRequestValue,
): Partial<Record<PriceFieldKey, string>> {
    const vatRate = parseAmount(values.vatRate);
    if (vatRate === undefined) {
        return {};
    }
    const factor = 1 + vatRate / 100;

    if (editedKey === 'grossPrice') {
        const gross = parseAmount(values.grossPrice);
        return gross === undefined ? {} : { netPrice: (gross / factor).toFixed(2) };
    }

    const net = parseAmount(values.netPrice);
    if (net !== undefined) {
        return { grossPrice: (net * factor).toFixed(2) };
    }

    if (editedKey === 'vatRate') {
        const gross = parseAmount(values.grossPrice);
        if (gross !== undefined) {
            return { netPrice: (gross / factor).toFixed(2) };
        }
    }
    return {};
}
